import type { NotifyMeMessageType } from '@velasca/types'
import { isSummerNotifyMe } from './isSummerNotifyMe'
import { isWinterNotifyMe } from './isWinterNotifyMe'

type ValidTranslationKey =
  | 'notify_soon_winter'
  | 'notify_soon_summer'
  | 'notify_soon_limited'
  | 'notify_soon'

/**
 * Returns a string key used in react-i18next useLocalization's translation method
 * to print the correct "coming back soon" text based on the product season availability.
 *
 * @param notifyMe - The notify message type.
 * @returns A translation key.
 */
export const getComingBackSoonTranslationKey = (
  notifyMe: NotifyMeMessageType | undefined,
): ValidTranslationKey => {
  if (notifyMe === 'limited') {
    return 'notify_soon_limited'
  }

  if (notifyMe === 'season-winter') {
    return isWinterNotifyMe() ? 'notify_soon' : 'notify_soon_winter'
  }

  if (notifyMe === 'season-summer') {
    return isSummerNotifyMe() ? 'notify_soon' : 'notify_soon_summer'
  }

  return 'notify_soon'
}
